import * as Yup from "yup";

export const getPasswordValidation = (passwordRequiredMessage: string, passwordNotValidString: string) =>
    Yup.string().required(passwordRequiredMessage).matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!#$%&()*,/:;<=>?@[\]^_{|}~])[A-Za-z\d!#$%&()*,/:;<=>?@[\]^_{|}~]{8,}$/,
        passwordNotValidString,
    );

export const changePasswordValidation = (passwordRequiredMessage: string, passwordNotValidString: string,
                                         canotChangeToOldPasswordMessage: string, oldPassword: string) =>
    getPasswordValidation(passwordRequiredMessage, passwordNotValidString).notOneOf([oldPassword],
        (canotChangeToOldPasswordMessage));

// TODO - add more test cases for password validations
